import type {FC} from 'react';
import ReactConfetti from 'react-confetti';

import type {Props} from './types';

import {COLORS} from './utils';

export const Confetti: FC<Props> = ({
  colors = COLORS,
  recycle = false,
  run = true,
  testID,
  ...rest
}) => {
  if (!run) {
    return null;
  }

  return (
    <ReactConfetti
      {...rest}
      colors={colors}
      data-test-id={testID}
      recycle={recycle}
    />
  );
};
